// titles.ts

export const titles: string[] = [
    'Mr',
    'Mrs',
    'Miss',
    'Ms',
    'Dr',
    'Prof',
    'Sir',
    'Madam',
    'Mx',
    'Rev',
    'Fr',
    'Sr',
    'Br',
    'Capt',
    'Lt',
    'Col',
    'Maj',
    'Sgt',
    'Cpl',
    'Const',
    'Chief',
    'Sheikh',
    'Princess',
    'Prince',
    'Lord',
    'Lady',
    'Count',
    'Countess',
    'Duke',
    'Duchess',
    'Baron',
    'Baroness',
    'Ambassador',
  ];
  